import type { PuckExtensionSectorOption } from "src/components/PuckExtensions";

export const mergeRoleOptions = (allowedRoles: string[], availableRoles: string[]): string[] =>
    Array.from(new Set([...allowedRoles, ...availableRoles]));

export const mergeSectorOptions = (
    selectedSectorIris: string[],
    availableSectors: PuckExtensionSectorOption[],
): string[] => Array.from(new Set([...selectedSectorIris, ...availableSectors.map((sector) => sector.iri)]));

export const getSectorDisplayName = (sectorIri: string, availableSectors: PuckExtensionSectorOption[]): string =>
    availableSectors.find((sector) => sector.iri === sectorIri)?.name ?? sectorIri;
